import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  CityObjectYearReportExportRequestType,
  CityObjectYearReportRequestType,
  CityObjectYearReportSummaryResponseType,
  CityObjectYearReportDetailRow,
  CityObjectYearReportByContractRow,
  CityObjectYearReportByItemRow,
} from "../types/CityObjectYearReport";

const baseUrl = "/api/CityObjectYearReport";

export const postYearReportSummary = async (
  body: CityObjectYearReportRequestType,
): Promise<CityObjectYearReportSummaryResponseType> => {
  const token = await getApiAccessToken();
  const response = await apiClient.post(`${baseUrl}/summary`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data as CityObjectYearReportSummaryResponseType;
};

export const exportYearReportCsv = async (
  body: CityObjectYearReportExportRequestType,
): Promise<Blob> => {
  const token = await getApiAccessToken();
  const response = await apiClient.post(`${baseUrl}/export`, body, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
  return response.data as Blob;
};

export const exportYearReportData = async (
  body: CityObjectYearReportExportRequestType,
): Promise<
  | CityObjectYearReportDetailRow[]
  | CityObjectYearReportByContractRow[]
  | CityObjectYearReportByItemRow[]
> => {
  const token = await getApiAccessToken();
  const response = await apiClient.post(`${baseUrl}/export-data`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data as
    | CityObjectYearReportDetailRow[]
    | CityObjectYearReportByContractRow[]
    | CityObjectYearReportByItemRow[];
};

